<template>
  <div>
    <h2>Authors</h2>

    <v-card class="pa-2 mt-5 d-flex">
      <v-text-field
        outlined
        hide-details
        v-model="search"
        label="Search list"
        prepend-inner-icon="mdi-account-search"
      ></v-text-field>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="filteredAuthors"
      :items-per-page="10"
      class="elevation-1 mt-5 mb-8"
    >
      <template v-slot:[`item.firstName`]="{ item }">
        <span style="white-space: nowrap">
          {{ item.title }} {{ item.firstName }} {{ item.lastName }}
        </span>
      </template>
      <template v-slot:[`item.department`]="{ item }">
        {{ item.department }} <br />
        <span
          v-if="item.specialization"
          class="text-uppercase mb-1"
          style="font-size: 10px"
        >
          Specl: {{ item.specialization }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    createAccount: false,

    users: [],

    search: "",

    headers: [
      { text: "Full Name", align: "start", value: "firstName" },
      { text: "Institution", value: "institution" },
      { text: "Department/College", value: "department" },
      { text: "Email", value: "email" },
      { text: "Phone", value: "phone" },
      // { text: "Actions", value: "_id", sortable: false },
    ],

    selectedUser: null,
  }),
  computed: {
    filteredAuthors() {
      return [...this.users].filter((user) => {
        const term = this.search.toLowerCase();
        return (
          user.title.toLowerCase().includes(term) ||
          user.lastName.toLowerCase().includes(term) ||
          user.firstName.toLowerCase().includes(term) ||
          user.email.toLowerCase().includes(term) ||
          (user.phone && user.phone.toLowerCase().includes(term)) ||
          (user.institution && user.institution.toLowerCase().includes(term)) ||
          (user.department && user.department.toLowerCase().includes(term)) ||
          (user.specialization &&
            user.specialization.toLowerCase().includes(term))
        );
      });
    },
  },
  methods: {
    fetchAuthors() {
      this.loading = true;
      this.$axios
        .get("/editorial/authors")
        .then(({ data: response }) => {
          this.users = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve users",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetailsDialog(account) {
      this.$forceUpdate();
      this.selectedUser = account;
    },
  },
  mounted() {
    this.fetchAuthors();
  },
};
</script>

<style>
</style>